import React from 'react';
import { BokunLogo } from '../BokunLogo/BokunLogo';
import { Link as RouterLink } from 'react-router-dom';
import { Typography } from '@material-ui/core';
import styled from 'styled-components';

const StyledTitle = styled.span`
    margin-left: 12px;
    font-weight: 300;
    color: #363a3f !important;
`;

const RouterLinkStyled = styled(RouterLink)`
    text-decoration: none;

    ${StyledTitle} {
        position: relative;
        top: -1px;
    }
`;

interface HeaderLogoProps {
    linkTo?: string;
    title?: string;
}

export const HeaderLogo = ({ linkTo = '/', title = 'App Store' }: HeaderLogoProps): JSX.Element => {
    return (
        <Typography variant="h6" style={{ flex: '1' }}>
            <RouterLinkStyled to={linkTo}>
                <BokunLogo scale={0.6} />
                <StyledTitle>{title}</StyledTitle>
            </RouterLinkStyled>
        </Typography>
    );
};
